// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {

});



// export function allCategory_mouseIn(event, $w) {
// 	$w('#Menu').expand()//Add your code for this event here: 
// }

// export function allCategory_mouseOut(event, $w) {
// 	$w('#Menu').collapse()//Add your code for this event here: 
// }

export function Menu_mouseIn(event) {
	$w('#Menu').expand()//Add your code for this event here: 
}

export function Menu_mouseOut(event) {
	$w('#Menu').collapse()//Add your code for this event here: 
}

export function allCategory_click(event) {
	if ($w('#Menu').collapsed) {
		$w('#Menu').expand()
	} else {
		$w('#Menu').collapse()
	}
	//Add your code for this event here: 
}



